import { Box, Button, CircularProgress, Divider, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";

import { getUserDiscountCodes } from "../../util/api/userApi";


const DiscountCodes = ({ refreshKey = 0 }) => {
  const [codes, setCodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);

  const loadCodes = useCallback(() => {
    setLoading(true);
    setLoadError(false);
    getUserDiscountCodes().then((response) => {
      setCodes(response.data);
    }).catch(() => {
      setCodes([]);
      setLoadError(true);
    }).finally(() => {
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    loadCodes();
  }, [loadCodes, refreshKey]);

  if (loading) {
    return <CircularProgress aria-label="Loading discount codes" size={24} sx={{ color: "black", mb: 5 }} />;
  }

  if (!loadError && codes.length === 0) {
    return null;
  }

  return <Box sx={{ backgroundColor: "#fff", color: "#171717", mb: 5 }}>
    <Typography sx={{ color: "#171717", fontWeight: 600 }} variant="h4">
      Discount codes
    </Typography>
    <Divider sx={{ borderColor: "#b8b8b8", mt: 1, mb: 3 }} />

    {loadError && <Box>
      <Typography sx={{ color: "#4f4f4f", fontSize: "0.8rem", mb: 1 }}>
        Your discount codes are temporarily unavailable.
      </Typography>
      <Button onClick={loadCodes} size="small" sx={{ backgroundColor: "#24211e", color: "#fff" }} variant="contained">
        Retry
      </Button>
    </Box>}

    {!loadError && codes.map((discount) => <Box
      key={discount.id}
      sx={{
        alignItems: { xs: "flex-start", sm: "center" },
        background: "linear-gradient(120deg, #2a080a 0%, #7d171a 100%)",
        borderRadius: 2,
        color: "#fff",
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        gap: 2,
        justifyContent: "space-between",
        p: 2,
      }}
    >
      <Box>
        <Typography sx={{ fontSize: "1rem", fontWeight: 700 }}>
          {discount.percent_off}% off BassSuite - Distant
        </Typography>
        <Typography sx={{ fontSize: "0.8rem", mb: 1 }}>
          One-time discount for ToneSuite - Distant owners
        </Typography>
        <Box
          aria-label="Discount code"
          component="code"
          sx={{
            backgroundColor: "rgba(255, 255, 255, 0.14)",
            border: "1px solid rgba(255, 255, 255, 0.45)",
            borderRadius: 1,
            display: "inline-block",
            fontSize: "1rem",
            fontWeight: 700,
            letterSpacing: "0.08em",
            px: 1.5,
            py: 0.75,
          }}
        >
          {discount.code}
        </Box>
      </Box>
      <Button
        href="/product/distant-bass-suite"
        sx={{ backgroundColor: "#fff", color: "#7d171a", flexShrink: 0, fontWeight: 700 }}
        variant="contained"
      >
        Shop BassSuite
      </Button>
    </Box>)}
  </Box>;
};

export default DiscountCodes;
